const force24HourFormat = (timeStr) => {
  const [hoursRaw, minutes] = timeStr.split(':');
  let hours = parseInt(hoursRaw, 10);

  if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
    const isPM = timeStr.toLowerCase().includes('pm');
    if (isPM && hours < 12) hours += 12;
    if (!isPM && hours === 12) hours = 0;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes}`;
};

const force12HourFormat = (rawTime) => {
  if (typeof rawTime !== 'string') throw new Error('Time must be a string');

  const clean = rawTime.trim().toUpperCase();
  const hasAMPM = clean.includes('AM') || clean.includes('PM');

  const timeOnly = clean.replace(/[^0-9:]/g, '');
  const parts = timeOnly.split(':');

  if (parts.length < 2) throw new Error('Invalid time format');

  const [hourStr, minuteStr] = parts;
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  if (Number.isNaN(hour) || Number.isNaN(minute) || hour > 23 || minute > 59) {
    throw new Error('Invalid hour or minute');
  }

  let isPM = false;

  if (hasAMPM) {
    isPM = clean.includes('PM');
    if (isPM && hour < 12) hour += 12;
    if (!isPM && hour === 12) hour = 0;
  }

  const displayHour = ((hour + 11) % 12) + 1;
  const suffix = hour < 12 ? 'AM' : 'PM';

  return `${displayHour}:${minute.toString().padStart(2, '0')} ${suffix}`;
};

const Time = {
  force24HourFormat,
  force12HourFormat,
};

export default Time;
